<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        filterable
        style=" margin-right: 10px"
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
      >
        <el-option label="全部" value="-1"></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>

      <el-select
        filterable
        style=" margin-right: 10px"
        v-model="screen.identifier"
        placeholder="请选择进出标识"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.title"
          :value="item.id"
          v-for="(item, index) in statusList"
          :key="index"
        ></el-option>
      </el-select>
      <el-date-picker
      style=" margin-right: 10px"
      value-format="yyyy-MM-dd HH:mm:ss"
      v-model="screen.start_time"
      type="datetime"
      placeholder="选择开始时间">
    </el-date-picker>
    <el-date-picker
    style=" margin-right: 10px"
    value-format="yyyy-MM-dd HH:mm:ss"
      v-model="screen.end_time"
      type="datetime"
      placeholder="选择结束时间">
    </el-date-picker>
    
    <el-input
    
    style=" margin-right: 10px;width: 200px;"
        v-model="screen.car_number"
        placeholder="请输入车牌号模糊查询"
      ></el-input>
      <el-button
        type="primary"
        @click="(screen.page = 1), fetchData()"
        style="margin-bottom: 5px;"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px;"
        >重置</el-button
      >
    </div>

    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="id" label="ID" width="100"> </el-table-column> -->
      <el-table-column label="所属园区" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park_name ? scope.row.park_name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="设备名称" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.device_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否离场" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.is_out_text }}</span>
        </template>
      </el-table-column>
      <el-table-column label="停车类型" width="120">
        <template slot-scope="scope">
          <span>{{
            scope.row.type == 1
              ? "套餐车"
              : scope.row.type == 2
              ? "临时车" : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="车牌号" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.car_number }}</span>
        </template>
      </el-table-column>
      <el-table-column label="车牌颜色" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.car_color == 'blue'">蓝</span>
          <span v-if="scope.row.car_color == 'yellow'">黄</span>
          <span v-if="scope.row.car_color == 'white'">白</span>
          <span v-if="scope.row.car_color == 'green'">绿</span>
          <span v-if="scope.row.car_color == 'black'">黑</span>
          <span v-if="scope.row.car_color == 'unknow'">其他</span>
        </template>
      </el-table-column>
      <el-table-column label="进场时间" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.in_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="进场图片" min-width="200">
        <template slot-scope="scope">
          <p v-if="scope.row.in_image">
            <el-image
              :src="scope.row.in_image"
              class="tableIcon"
              fit="contain"
              :preview-src-list="scope.row.in_image.split(',')"
            >
            </el-image>
          </p>
        </template>
      </el-table-column>
      <el-table-column label="出场时间" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.out_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="出场图片" min-width="200">
        <template slot-scope="scope">
          <p v-if="scope.row.out_image">
            <el-image
              :src="scope.row.out_image"
              class="tableIcon"
              fit="contain"
              :preview-src-list="scope.row.out_image.split(',')"
            >
            </el-image>
          </p>
        </template>
      </el-table-column>
      <el-table-column label="停留时间" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.time_count }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="created_at" label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="examine(scope.row.id)"
            v-if="
              roles.includes('/carport/order_refund') &&
              scope.row.pay_status == 2 &&  scope.row.actual_receipt != 0 &&  scope.row.is_invoce == 0
            "
            >退款</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { openPark } from "@/api/index";
import { get_car_record,} from "@/api/parking";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      statusList: [
        {
          title: "进",
          id: 'in',
        },
        {
          title: "出",
          id: 'out',
        }
      ],
      screen: {
        page: 1,
        page_size: 15,
        park_id: "-1",
        identifier:'',
        start_time:'',
        end_time:'',
        car_number:''
      },
      total: 0,
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      form: {
        id: "",
        status: "",
        reason: "",
      },
      rules: {
        status: [{ required: true, message: "请选择审核", trigger: "change" }],
        reason: [
          { required: true, message: "请输入驳回意见", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "-1";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    reset() {
      this.screen = {
        park_id: "-1",
        page: 1,
        page_size: 15,
        start_time: "",
        end_time: "",
        identifier: "",
        car_number:''
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "-1";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      get_car_record(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
</style>
